
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function LowCarbonPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-teal-50 via-white to-emerald-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-6">
            <Link to="/" className="text-gray-500 hover:text-teal-500 transition-colors">
              <i className="ri-home-line"></i>
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <Link to="/services" className="text-gray-500 hover:text-teal-500 transition-colors">
              服務方案
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-teal-600 font-medium">低碳智慧化補助</span>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="inline-block bg-teal-500 text-white text-sm font-semibold px-4 py-2 rounded-full mb-6">
                <i className="ri-leaf-line mr-2"></i>設備升級
              </span>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                低碳智慧化補助
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed mb-8">
                經濟部低碳智慧化補助，係由經濟部推動之政策型補助方案，目的在於協助企業導入低碳化、智慧化及數位轉型相關技術與設備，提升營運效率、降低碳排放，並強化企業中長期競爭力。
              </p>
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/contact"
                  className="px-8 py-4 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-lg font-semibold hover:from-teal-600 hover:to-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  立即諮詢此方案
                </Link>
                <a
                  href="https://line.me/R/ti/p/@678gwbht"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-[#06C755] text-white rounded-lg font-semibold hover:bg-[#05b34c] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-line-fill text-xl"></i>
                  LINE 諮詢
                </a>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/6534c96261f604a4c45c21bcd4f6bb44.jpg"
                alt="低碳智慧化"
                className="w-full h-[400px] object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 專案概述 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-8">專案概述</h2>
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-6">
                經濟部低碳智慧化補助,係由經濟部推動之政策型補助方案,目的在於協助企業導入低碳化、智慧化及數位轉型相關技術與設備,提升營運效率、降低碳排放,並強化企業中長期競爭力。
              </p>
              <p className="text-gray-700 leading-relaxed">
                本補助屬於實質補助性質,不同於貸款或融資工具,企業通過審查後,可依核定比例獲得政府補助款。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 制度設計重點說明 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">制度設計重點說明</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-teal-500 to-teal-600 mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-2xl p-8 border-2 border-teal-100 hover:border-teal-300 transition-all shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-gift-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">補助性質</h3>
              <p className="text-gray-600 leading-relaxed">
                屬政府補助款,非貸款,無須償還
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 border-2 border-teal-100 hover:border-teal-300 transition-all shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-focus-2-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">政策目標</h3>
              <p className="text-gray-600 leading-relaxed">
                協助企業進行低碳轉型、智慧製造與數位升級
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 border-2 border-teal-100 hover:border-teal-300 transition-all shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-hand-coin-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">補助方式</h3>
              <p className="text-gray-600 leading-relaxed">
                依核定計畫內容,補助企業部分導入或建置成本
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 border-2 border-teal-100 hover:border-teal-300 transition-all shadow-lg">
              <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-file-search-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">審查機制</h3>
              <p className="text-gray-600 leading-relaxed">
                採計畫審查制,重視可行性、效益與落地性
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 適用對象 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">適用對象</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-teal-500 to-teal-600 mx-auto"></div>
          </div>

          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              低碳智慧化補助主要適用於:
            </p>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-4-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">中小企業及具實質營運之公司</h3>
                  <p className="text-gray-600">具備合法登記與實際營運之企業主體</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-2-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">製造業、服務業或具轉型需求之產業</h3>
                  <p className="text-gray-600">各類產業皆可申請,重點在於轉型需求明確</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-list-3-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">具明確改善目標與導入計畫之企業</h3>
                  <p className="text-gray-600">需提出完整計畫書,說明導入目標與預期效益</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-leaf-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">願意投入低碳、節能或智慧化升級之營運主體</h3>
                  <p className="text-gray-600">具備轉型意願與執行能力之企業</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 補助項目與適用範圍 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">補助項目與適用範圍（常見方向）</h2>
            <p className="text-gray-600 text-lg">實際補助內容依年度公告為準,常見補助方向包括:</p>
            <div className="w-20 h-1 bg-gradient-to-r from-teal-500 to-teal-600 mx-auto mt-4"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center">
                  <i className="ri-leaf-line text-3xl text-teal-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">低碳化與節能</h3>
              </div>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-lg mt-0.5"></i>
                  <span className="text-gray-700">低碳化導入</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-lg mt-0.5"></i>
                  <span className="text-gray-700">節能設備更新</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-lg mt-0.5"></i>
                  <span className="text-gray-700">製程減碳與能源效率改善</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-lg mt-0.5"></i>
                  <span className="text-gray-700">碳排放監測與管理系統</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center">
                  <i className="ri-cpu-line text-3xl text-teal-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">智慧化與數位轉型</h3>
              </div>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-lg mt-0.5"></i>
                  <span className="text-gray-700">智慧製造、智慧設備導入</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-lg mt-0.5"></i>
                  <span className="text-gray-700">自動化系統、感測與數據整合</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-lg mt-0.5"></i>
                  <span className="text-gray-700">AI、IoT、MES、ERP 等系統建置</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-lg mt-0.5"></i>
                  <span className="text-gray-700">營運流程數位化</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-500 text-lg mt-0.5"></i>
                  <span className="text-gray-700">系統整合與資訊安全強化</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 與一般貸款或融資工具的差異 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">與一般貸款或融資工具的差異</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-teal-500 to-teal-600 mx-auto"></div>
          </div>

          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              相較於銀行貸款或政策性融資工具,低碳智慧化補助具備以下特性:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-6 border-2 border-teal-100">
                <div className="flex items-start gap-3">
                  <i className="ri-gift-line text-2xl text-teal-600 mt-1"></i>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">屬補助款,非舉債行為</h3>
                    <p className="text-gray-600 text-sm">無需償還,不增加企業負債</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-6 border-2 border-teal-100">
                <div className="flex items-start gap-3">
                  <i className="ri-line-chart-line text-2xl text-teal-600 mt-1"></i>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">不影響企業負債比或授信額度</h3>
                    <p className="text-gray-600 text-sm">保持財務彈性,不占用融資空間</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-6 border-2 border-teal-100">
                <div className="flex items-start gap-3">
                  <i className="ri-stack-line text-2xl text-teal-600 mt-1"></i>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">可與企業自有資金或銀行融資搭配使用</h3>
                    <p className="text-gray-600 text-sm">多元資金組合,降低轉型成本</p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-6 border-2 border-teal-100">
                <div className="flex items-start gap-3">
                  <i className="ri-focus-3-line text-2xl text-teal-600 mt-1"></i>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">補助重點在「轉型成效」,非企業財務規模</h3>
                    <p className="text-gray-600 text-sm">重視計畫可行性與預期效益</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 專業提醒 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="bg-amber-50 border-2 border-amber-200 rounded-2xl p-8">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-error-warning-line text-2xl text-amber-600"></i>
                </div>
                <h2 className="text-2xl font-bold text-gray-900">專業提醒</h2>
              </div>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-amber-600 text-lg mt-0.5 flex-shrink-0"></i>
                  <span className="text-gray-700">補助採計畫制,需事前完整規劃並備妥相關文件</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-amber-600 text-lg mt-0.5 flex-shrink-0"></i>
                  <span className="text-gray-700">非所有支出項目皆可補助,需符合當年度公告範圍</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-amber-600 text-lg mt-0.5 flex-shrink-0"></i>
                  <span className="text-gray-700">審查重視「實際導入效益」,非僅設備購置</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-amber-600 text-lg mt-0.5 flex-shrink-0"></i>
                  <span className="text-gray-700">通常需配合成果查核與後續追蹤</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 總結說明 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-8">總結說明</h2>
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed text-lg">
                經濟部低碳智慧化補助是一項以補助方式協助企業進行低碳轉型與智慧升級的政策方案,目的在於降低企業轉型成本、提升營運效率,並強化企業永續發展與中長期競爭力。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-500 to-teal-600">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            把握政府補助,加速企業轉型升級
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            朋睿專業顧問協助您撰寫計畫書、準備文件,提高補助核准率
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-4 bg-white text-teal-600 text-lg font-semibold rounded-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              免費諮詢
            </Link>
            <Link
              to="/services"
              className="px-8 py-4 bg-transparent text-white text-lg font-semibold rounded-lg border-2 border-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              查看其他方案
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* LINE 客服按鈕 */}
      <a
        href="https://line.me/R/ti/p/@678gwbht"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-28 right-6 z-40 w-14 h-14 bg-[#06C755] rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform duration-300 group"
        aria-label="LINE 即時諮詢"
      >
        <i className="ri-line-fill text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          LINE 即時諮詢
        </span>
      </a>
    </div>
  );
}
